import React from 'react';
import {Link, useRouteMatch} from "react-router-dom";
import * as Index from "./Index";

const current = "/~Solferino/writing/excavation";

// 用語集(#dfn-*)の定義文を取得する。定義の単一ソースは用語集の dd。
function dfnDefinition(id: string): string {
  const dfn = document.getElementById(id);
  const dt = dfn?.closest("dt");
  const dd = dt?.nextElementSibling;
  if (!dd || dd.tagName !== "DD") return "";
  return (dd.textContent || "").replace(/\s+/g, " ").trim();
}

// 用語リンク(a.dfd)に語義を title ツールチップとして付与する。
// 語録がページ末尾にあるため、飛ばずにホバーで意味を読めるようにする。既存 title は尊重。
function applyDfnTitles(root: ParentNode | null): void {
  root?.querySelectorAll("a.dfd").forEach((a) => {
    const href = a.getAttribute("href") || "";
    if (!href.startsWith("#dfn-") || a.getAttribute("title")) return;
    const def = dfnDefinition(href.slice(1));
    if (def) a.setAttribute("title", def);
  });
}

export function BuildPage(): Page {
  return {title: "Webリソース発掘法", path: current, parent: Index.BuildPage()};
}

export function Render(props: SolferinoProps) {
  const [rendered, setRendered] = React.useState(false);

  const isExact = useRouteMatch(current)?.isExact;
  React.useEffect(() => {
    if (isExact && !rendered) {
      setRendered(true);
      props.setPage(BuildPage());
    }
  }, [isExact, rendered, props]);

  // 用語リンク(a.dfd)に語義 title を付与する (ページ末尾の用語集を飛ばずに読めるように)
  React.useEffect(() => {
    applyDfnTitles(document.querySelector(".Writing-Excavation"));
  });

  return (
    <div className="Writing-Excavation">
      <p>今公開されてないからって、見られないかどうかはわからない！</p>
      <p><em className="hur">お急ぎの方は『<a href="#S9-2" title="Webリソース発掘法 忙しい人のためのWebリソース発掘法">忙しい人のためのWebリソース発掘法</a>』へどうぞ</em></p>
      <h2 id="S1">目次</h2>
      <ol>
      <li className="tit"><a href="#S" title="Webリソース発掘法">Webリソース発掘法</a></li>
      <li className="mar"><a href="#S1" title="Webリソース発掘法 目次">目次</a></li>
      <li className="mar"><a href="#S2" title="Webリソース発掘法 注意書き">注意書き</a></li>
      <li className="mar"><a href="#S3" title="Webリソース発掘法 『発掘』とは、どういうことか？">『発掘』とは、どういうことか？</a></li>
      <li className="exp"><a href="#S3-1" title="Webリソース発掘法 時は、まさに戦国時代">時は、まさに戦国時代</a></li>
      <li className="exp"><a href="#S3-2" title="Webリソース発掘法 保管能力の限界">保管能力の限界</a></li>
      <li className="exp"><a href="#S3-3" title="Webリソース発掘法 消しても消えない遺物たち">消しても消えない遺物たち</a></li>
      <li className="exp"><a href="#S3-4" title="Webリソース発掘法 情報を発掘しよう！">情報を発掘しよう！</a></li>
      <li className="exp"><a href="#S3-5" title="Webリソース発掘法 数ある方法から発掘を選ぶ理由">数ある方法から発掘を選ぶ理由</a></li>
      <li className="mar"><a href="#S4" title="Webリソース発掘法 どのように発掘を行うか">どのように発掘を行うか</a></li>
      <li className="exp"><a href="#S4-1" title="Webリソース発掘法 何から手をつける？">何から手をつける？</a></li>
      <li className="exp"><a href="#S4-1-" title="Webリソース発掘法 発掘フローチャート">（発掘フローチャート）</a></li>
      <li className="exp"><a href="#S4-2" title="Webリソース発掘法 目標を設定する">１．目標を設定する</a></li>
      <li className="exp"><a href="#S4-3" title="Webリソース発掘法 既知の情報をまとめる">２．既知の情報をまとめる</a></li>
      <li className="exp"><a href="#S4-4" title="Webリソース発掘法 手段を策定する">３．手段を策定する</a></li>
      <li className="exp"><a href="#S4-5" title="Webリソース発掘法 根気よく探す">４．根気よく探す</a></li>
      <li className="exp"><a href="#S4-6" title="Webリソース発掘法 連携技で掘り進め！">連携技で掘り進め！</a></li>
      <li className="mar"><a href="#S5" title="Webリソース発掘法 見つけ出したいこんな手がかり">見つけ出したいこんな手がかり</a></li>
      <li className="exp"><a href="#S5-1" title="Webリソース発掘法 手がかりは目標の一部">手がかりは目標の一部</a></li>
      <li className="exp"><a href="#S5-2" title="Webリソース発掘法 “目標”が必要とする手がかり">“目標”が必要とする手がかり</a></li>
      <li className="exp"><a href="#S5-3" title="Webリソース発掘法 “手がかり”を見つけ出す方法">“手がかり”を見つけ出す方法</a></li>
      <li className="exp"><a href="#S5-4" title="Webリソース発掘法 “情報”から見つけ出せる手がかり">“情報”から見つけ出せる手がかり</a></li>
      <li className="mar"><a href="#S6" title="Webリソース発掘法 どんな道具が使えるのか">どんな道具が使えるのか</a></li>
      <li className="exp"><a href="#S6-1" title="Webリソース発掘法 手段は星の数">手段は星の数</a></li>
      <li className="exp"><a href="#S6-2" title="Webリソース発掘法 検索エンジン">検索エンジン</a></li>
      <li className="exp"><a href="#S6-2-1" title="Webリソース発掘法 基本の使い方">（基本の使い方）</a></li>
      <li className="exp"><a href="#S6-2-2" title="Webリソース発掘法 詳しい検索方法">（詳しい検索方法）</a></li>
      <li className="exp"><a href="#S6-2-3" title="Webリソース発掘法 検索オプション">（検索オプション）</a></li>
      <li className="exp"><a href="#S6-2-4" title="Webリソース発掘法 検索種別">（検索種別）</a></li>
      <li className="exp"><a href="#S6-2-5" title="Webリソース発掘法 検索エンジンの選択">（検索エンジンの選択）</a></li>
      <li className="exp"><a href="#S6-3" title="Webリソース発掘法 Internet Archive Wayback Machine">Internet Archive Wayback Machine</a></li>
      <li className="mar"><a href="#S7" title="Webリソース発掘法 発掘“ケースバイケース”">発掘“ケースバイケース”</a></li>
      <li className="exp"><a href="#S7-1" title="Webリソース発掘法 こんなときどうすればいいの？">こんなときどうすればいいの？</a></li>
      <li className="exp"><a href="#S7-2" title="Webリソース発掘法 目標設定に関する問題">目標設定に関する問題</a></li>
      <li className="exp"><a href="#S7-3" title="Webリソース発掘法 手がかりに関する問題">手がかりに関する問題</a></li>
      <li className="exp"><a href="#S7-4" title="Webリソース発掘法 手段に関する問題">手段に関する問題</a></li>
      <li className="exp"><a href="#S7-5" title="Webリソース発掘法 効率に関する問題">効率に関する問題</a></li>
      <li className="exp"><a href="#S7-6" title="Webリソース発掘法 その他の問題">その他の問題</a></li>
      <li className="exp"><a href="#S7-" title="Webリソース発掘法 発掘ケースバイケースの使い方">発掘ケースバイケースの使い方</a></li>
      <li className="mar"><a href="#S8" title="Webリソース発掘法 実際にやってみた">実際にやってみた</a></li>
      <li className="mar"><a href="#S9" title="Webリソース発掘法 その他あれこれ">その他あれこれ</a></li>
      <li className="exp"><a href="#S9-1" title="Webリソース発掘法 発掘の歴史">発掘の歴史</a></li>
      <li className="exp"><a href="#S9-2" title="Webリソース発掘法 忙しい人のためのWebリソース発掘法">忙しい人のためのWebリソース発掘法</a></li>
      <li className="mar"><a href="#S10" title="Webリソース発掘法 用語集">用語集</a></li>
      </ol>
      <h2 id="S2">注意書き</h2>
      <p>
      このページは、既に存在する<a className="dfd" href="#dfn-worldWideWeb">WWW</a>用情報<a className="dfd" href="#dfn-search">検索</a>技術を、“過去へ遡るという観点から纏め直す”という試みの基に作られました。
      そのため、書かれている内容に関しては筆者オリジナルのものでは無いという事を、あらかじめ御了承下さい。
      </p><p>
      その他、本ページの利用に関しては本サイトの『<Link to={"/~Solferino/notes"}>利用上の諸注意</Link>』をご覧ください。
      </p>
      <h2 id="S3">S3『<a className="dfd" href="#dfn-excavate">発掘</a>』とは、どういうことか？</h2>
      <h3 id="S3-1">時は、まさに戦国時代</h3>
      <p>
      <a className="dfd" href="#dfn-webPage">Webページ</a>は栄枯盛衰。
      昨日あった<a className="dfd" href="#dfn-webPage">ページ</a>が今日消滅し、今日なかった<a className="dfd" href="#dfn-webPage">ページ</a>が明日には出現します。
      必要なデータは、見つけた時点で<a className="dfd" href="#dfn-secure">確保</a>しておく必要があるのです。
      </p>
      <h3 id="S3-2">保管能力の限界</h3>
      <p>
      しかし、見たもの全てを<a className="dfd" href="#dfn-secure">保管</a>しておくことはできません。
      装置には<a className="dfd" href="#dfn-capacity">容量</a>というものが存在するからです。
      </p><p>
      もちろん、サイズの小さいデータだけでも<a className="dfd" href="#dfn-secure">確保</a>しておけば、困ることはぐっと減るでしょう。
      それでも、貼ってあるリンクの先まで全て<a className="dfd" href="#dfn-secure">保管</a>するのは現実的な話ではありません。
      それに、すでになくなっている<a className="dfd" href="#dfn-webPage">ページ</a>に対して、この方法はあまりに無力です。
      </p><p>
      では、<a className="dfd" href="#dfn-compile">収集</a>できなかったデータに関しては、諦めるしかないのでしょうか？
      </p>
      <h3 id="S3-3">消しても消えない<a className="dfd" href="#dfn-relic">遺物</a>たち</h3>
      <p>
      諦めてください。嘘です。
      </p><p>
      ……<a className="dfd" href="#dfn-worldWideWeb">Web</a>に一度公開した情報は、なかなか雲散霧消とはいかないものなのです。
      有名であればあるほど長く残ります。
      <a className="dfd" href="#dfn-bulletinBoardSystem">掲示板</a>で内容を語り合う人々がいれば、それがログになって残るでしょう。
      一部を引用して記事が書かれれば、それだって残ります。
      誰かが、消えてしまうのは惜しいからと<a className="dfd" href="#dfn-mirrorSite">ミラーサイト</a>を作るかもしれません。
      ことによると、丸ごとパクってオリジナル<a className="dfd" href="#dfn-webSite">サイト</a>などと名乗る不届き者だって現れるかもしれません。
      これらの状況は、複製が容易であるという電子情報の特徴から容易に起こります。
      そして拡散した情報は、オリジナルが何らかの原因で消滅しても、『<a className="dfd" href="#dfn-relic">遺物</a>』となって残り続けるのです……。
      </p>
      <h3 id="S3-4">情報を<a className="dfd" href="#dfn-excavate">発掘</a>しよう！</h3>
      <p>
      というわけで、<a className="dfd" href="#dfn-compile">収集</a>できなかったデータに関しては、これらの<a className="dfd" href="#dfn-relic">遺物</a>をログの地層から掘り出すという手があるのです。
      名前が見あたらなかったので、この方法を仮に『<a className="dfd" href="#dfn-excavation">Webリソース発掘法</a>』と名付けました。
      </p><p>
      <a className="dfd" href="#dfn-excavate">発掘</a>には、知識・<a className="dfd" href="#dfn-search">検索</a>能力・根気がいります。
      知識を元に大体の目標を定めたら、<a className="dfd" href="#dfn-search">検索</a>を駆使して<a className="dfd" href="#dfn-relic">遺物</a>のありそうな場所を探し、<a className="dfd" href="#dfn-excavate">発掘</a>します。
      存在しなかったら、別の<a className="dfd" href="#dfn-excavation">発掘法</a>を探ることになります。
      慣れれば、多少マイナーな<a className="dfd" href="#dfn-webSite">サイト</a>であっても<a className="dfd" href="#dfn-excavate">発掘</a>が可能となるでしょう。
      しかし、当然のことですが、それでもないものはないのです。
      時間を空けてみれば、状況は驚くほど変わります。
      昨日まで存在しなかった<a className="dfd" href="#dfn-relic">遺物</a>でも、今日は存在するということだってありうるのです。
      一刻を争うのでなければ、長い目で見て<a className="dfd" href="#dfn-excavate">発掘</a>を行ってください。
      </p><p>
      ……そうですね。
      一刻を争う場合のことも書いておかなければいけません。
      当然のことではあるのですが、<a className="dfd" href="#dfn-excavate">発掘</a>は消滅した情報を取り戻す唯一の方法ではないのです。
      </p>
      <h3 id="S3-5">数ある方法から<a className="dfd" href="#dfn-excavate">発掘</a>を選ぶ理由</h3>
      <p>
      他の方法には、例えば作者に問い合わせるというものがあります。
      作者にとってみれば、消えてしまったものは大切な自分の作品です。
      ハードディスクにしまっているかもしれません。
      また、他には違う媒体をあたるというものもあります。
      <a className="dfd" href="#dfn-worldWideWeb">Web</a>にないのならば、図書館にあるのかもしれないということです。
      昔は誰もがそうやって情報を集めていたわけですから。
      </p><p>
      では、何故“<a className="dfd" href="#dfn-excavation">Webリソース発掘法</a>”を利用するのでしょうか。
      </p><p>
      第一に、対象への影響を最小限に抑えられます。
      <a className="dfd" href="#dfn-excavate">発掘</a>は方法としてはとても消極的なもので、情報を新たに作り出して解決することを嫌います。
      <a className="dfd" href="#dfn-bulletinBoardSystem">掲示板</a>に書き込みをしたり質問箱に投函をしたりはしないということです。
      これによって、逆に必要な情報が消えてしまう等のリスクを小さくすることができます。
      もちろん、波及的に別の情報を損壊してしまう等といったものもほとんどなくなります。
      </p><p>
      第二に、当時の環境に近いものを再現することができます。
      再びよく似た情報が現れたとしても、それが同じものであるかどうかを確かめるのは難しいことです。
      しかし、もしも<a className="dfd" href="#dfn-mirrorSite">ミラーサイト</a>やWeb魚拓を発見することができれば、それが同じものである根拠を手に入れられます。
      どこかが改変されていたとしても、それを指摘することができるわけです。
      </p><p>
      第三に、これは<a className="dfd" href="#dfn-worldWideWeb">Web</a>環境内で完結する方法です。
      図書館や書店に出向く必要はありません。
      皆様にはそれぞれさまざまな事情があるでしょうが、この文章は<a className="dfd" href="#dfn-worldWideWeb">Web</a>で公開されている……はずです。
      なので、<a className="dfd" href="#dfn-worldWideWeb">Web</a>を利用するこの方法は皆様にも実行しやすいものであると思っています。
      </p><p>
      他にもいくつかありますが、おおまかにいえばこの三つが<a className="dfd" href="#dfn-excavate">発掘</a>の長所です。
      これらの特長に魅力を感じるのならば、<a className="dfd" href="#dfn-excavate">発掘</a>は適した方法だということになります。
      次の章からは、実際に<a className="dfd" href="#dfn-excavate">発掘</a>を行う手順を書いています。
      興味のある方は、そのまま読み進めていただければ幸いです。
      </p>
      <h2 id="S4">どのように<a className="dfd" href="#dfn-excavate">発掘</a>を行うか</h2>
      <h3 id="S4-1">何から手をつける？</h3>
      <p>
      それでは早速<a className="dfd" href="#dfn-relic">遺物</a>の<a className="dfd" href="#dfn-excavate">発掘</a>を始めましょう。
      掘ってください！
      </p><p>
      ……と言われても、どうすればいいのかわからない方がほとんどだと思われます。
      ここでは、<a className="dfd" href="#dfn-excavate">発掘</a>作業の“大体の流れ”について書いてみたいと思います。
      </p><dl>
      <dt className="tit" id="S4-1-"><a className="dfd" href="#dfn-excavate">発掘</a>フローチャート</dt>
      <dd className="tex">この通りにすれば<a className="dfd" href="#dfn-excavate">発掘</a>は簡単！(←おおかた簡単ではない)<dl>
      <dt className="mar">１．目標を設定する</dt>
      <dd className="exp">
      具体的な何かがあればそれを。
      無ければおおざっぱにでもいいので、目標を定めます。
      この時、欲張らないことが成功への近道です。
      </dd><dd className="exp">
      <em className="exam">今回は、“最近閉鎖してしまった<a className="dfd" href="#dfn-webSite">Webサイト</a>の小説”を目標にした、としましょう。</em>
      </dd>
      <dt className="mar">２．既知の情報をまとめる</dt>
      <dd className="exp">
      目標についてイメージしてください。
      また断片が手元にある場合は、それをじっくりと観察してください。
      そこから、特徴・個性などを見いだすのです。
      意外と手がかりは沢山あるはずです。
      題名・本文の内容・分類・作成年月日・アクセス日時・作者・<a className="dfd" href="#dfn-URL">URL</a>・リンク元・etc.
      これらが<a className="dfd" href="#dfn-relic">遺物</a>への水先案内人となって、あなたを導いてくれるでしょう。
      </dd><dd className="exp">
      <em className="exam">小説なので、題名や作者、本文の内容などの情報が重要となります。分類や<a className="dfd" href="#dfn-URL">URL</a>の情報も欲しいところです。</em>
      </dd>
      <dt className="mar">３．手段を策定する</dt>
      <dd className="exp">
      先ほど見つけた手がかりを元に、適した手段を選びます。
      それが文字列なら、<a className="dfd" href="#dfn-searchEngine">検索エンジン</a>に通してみるといいでしょう。
      分類や作成年月日から、<a className="dfd" href="#dfn-summarySite">まとめサイト</a>や<a className="dfd" href="#dfn-bulletinBoardSystem">掲示板</a>のログを漁ってみてもいいかもしれません。
      <a className="dfd" href="#dfn-URL">URL</a>の情報があれば、 <a className="dfd" href="#dfn-waybackMachine">Wayback Machine</a> の<a className="dfd" href="#dfn-archive">アーカイブ</a>が使えます。
      </dd><dd className="exp">
      <em className="exam">テキストコンテンツには、<a className="dfd" href="#dfn-search">検索</a>や <a className="dfd" href="#dfn-waybackMachine">Wayback Machine</a> が有効です。</em>
      </dd>
      <dt className="mar">４．根気よく探す</dt>
      <dd className="exp">
      手段が決まったら早速試してみましょう。
      すぐに出てくることもあれば、いくつも工夫を重ねてやっと頭を出すこともあります。
      行き詰まったように感じたら他の方法を試してみるか、時間を空けてみてください。
      きっと打開できるはずです。
      </dd><dd className="exp">
      <em className="exam">別の<a className="dfd" href="#dfn-webSite">サイト</a>に転載された分が残っていました――みたいな感じで見つかります。</em>
      </dd></dl></dd></dl><p>
      と、まぁこんな感じで<a className="dfd" href="#dfn-excavate">発掘</a>を行ってください。
      次の段からは、フローチャートの項目についてそれぞれ詳細に解説していきます。
      </p>
      <h3 id="S4-2">１．目標を設定する</h3>
      <p>
      目標を設定する上で重要なことは、『見つけられそうなもの』にするということです。
      <a className="dfd" href="#dfn-excavate">発掘</a>には基本終わりがないので、いつまでも探し続けることが可能です。
      なので、朝が来る前に見つけられそうな目標にしないと切ないことになります。
      ところで、見つけやすい目標とはどういうものでしょう。
      </p><p>
      情報は、時間とともに徐々に失われていきます。
      つまり、それが新しければ新しいほど完全な形で残っている可能性が高まります。
      また人気の情報は、様々な場所から参照されるため、コピーが拡散して意外な場所から見つかることがあります。
      他にも、需要が高ければ誰かによって<a className="dfd" href="#dfn-secure">保管</a>されている事が多くなります。
      </p><p>
      【年代】【人気】【需要】
      </p><p>
      この三つが『見つけられそうなもの』かどうかを決めます。
      ということは、これらが目標を設定する上で重要なことなのです。
      また、これらの要素が不足しているものを目標とすることはお勧めできません。
      <a className="dfd" href="#dfn-excavate">発掘</a>よりも強力な別の方法を試してください。
      </p>
      <h3 id="S4-3">２．既知の情報をまとめる</h3>
      <p>
      これに関しては、イメージが何よりも重要です。
      その情報が、どこにどのような形で転がっていそうか？　
      それを予想する知識が必要なのです。
      </p><p>
      <a className="dfd" href="#dfn-imageboard">画像掲示板</a>に貼ってあった、気になっている絵が流れてしまったとします。
      <a className="dfd" href="#dfn-imageboard">画像掲示板</a>は<a className="dfd" href="#dfn-capacity">容量</a>の関係から、過去ログが消えてしまうことがあります。
      こんな場合、どんな情報があれば<a className="dfd" href="#dfn-excavate">発掘</a>の可能性が高いのでしょうか。
      イメージしてください。
      あの絵がまだどこかに残っているとしたらどこにあるだろうか……。
      そして、そこから必要な情報を導き出すのです。
      下に、思いつく限りのイメージをまとめておいたので参考にしてください。
      </p><p>
      消えてすぐならキャッシュが残っているかもしれません。
      キャッシュは生ものなので、あとでまた必要な情報は、見つけたらすぐに<a className="dfd" href="#dfn-secure">確保</a>しておきましょう。
      また、<a className="dfd" href="#dfn-imageboard">画像掲示板</a>の場合<a className="dfd" href="#dfn-mirrorSite">ミラーサイト</a>の発見は期待できません。
      <a className="dfd" href="#dfn-capacity">容量</a>が大きく更新頻度も高いので保存しきれないのです。
      ただし、<a className="dfd" href="#dfn-imageboard">画像掲示板</a>の管理人が<a className="dfd" href="#dfn-secure">保管</a>している場合は別です。
      自<a className="dfd" href="#dfn-webSite">サイト</a>の情報なので、多少重くても保存していたりします。
      これらの場合、<a className="dfd" href="#dfn-URL">URL</a>やリンク元などの情報が重要となります。
      </p><p>
      作者自身がその画像を別の場所に転載していることがあります。
      この場合、作者の情報や題名・作成年月日などが重要となります。
      もちろん作者以外の手によって転載されている可能性もありますが、この場合は分類情報や本文の内容も重要な要素に加わります。
      ただしどちらの場合でも、付いていたコメントを補完するのは困難です。
      </p><p>
      手に入れるべき情報がわかったら、記憶や目標の断片などを利用してそれを集めていきます。
      時には手がかりを手に入れるために<a className="dfd" href="#dfn-excavate">発掘</a>を行うこともあるでしょう。
      これらの実際に情報を手に入れるまでの過程を、別の章にまとめることにしました。
      『<a href="#S5" title="Webリソース発掘法 見つけ出したいこんな手がかり">見つけ出したいこんな手がかり</a>』へどうぞ。
      </p>
      <h3 id="S4-4">３．手段を策定する</h3>
      <p>
      この段階で重要になるのは“見切り”です。
      例えば<a className="dfd" href="#dfn-searchEngine">検索エンジン</a>に語句を入力したとき、結果が数百件出てきたとします。
      実は数百件くらいなら、全ての結果を見て関連するかどうか確かめるのはそれほど難しくありません。
      この時、全てを見て回るか、別の方法を試すかを判断するのが見切りなのです。
      </p><p>
      <a className="dfd" href="#dfn-searchEngine">検索エンジン</a>は一つではありません。
      当然、<a className="dfd" href="#dfn-searchWord">検索語句</a>も一つではありません。
      また、<a className="dfd" href="#dfn-searchEngine">検索エンジン</a>には<a className="dfd" href="#dfn-imageSearch">画像検索</a>や<a className="dfd" href="#dfn-videoSearch">動画検索</a>も存在します。
      一つの<a className="dfd" href="#dfn-search">検索</a>にあまり時間をかけるべきではないかもしれません。
      こんな時に役に立つのが過去の経験です。
      感覚を頼りに思い切って選択していきましょう。
      </p><p>
      ところで、<a className="dfd" href="#dfn-excavate">発掘</a>する上で一番華やかなのがこの段階です。
      手段を道具と言い換えればよく理解できます。
      これを組み合わせて調整するのはそれだけでも楽しいものです。
      その一部でもここで紹介するのは手狭なので、新たに章を設けようと思います。
      『<a href="#S6" title="Webリソース発掘法 どんな道具が使えるのか">どんな道具が使えるのか</a>』でお会いしましょう。
      </p>
      <h3 id="S4-5">４．根気よく探す</h3>
      <p>
      根気よく物事を成し遂げる方法については、皆さんのほうがよくご存じだと思います。
      しかし、項目を作って『詳細に解説する』などと言ったからには何か書かないわけにはいきません。
      というわけで、ここではくじけそうになった時に考えてもらいたいことをまとめておきます。
      </p><p>
      『視野が狭くなってはいないか』
      よくある話ですが、一つ方法を思い付くとそれに固執してしまいがちです。
      見落としている情報はないか、他の方法を併用できないかなどを確認し、場合によっては捨てる勇気を持ちましょう。
      </p><p>
      『本当にそれは必要なものか』
      大切なのは自分の基準で考えることです。
      人には必要でも自分には魅力の感じられないものは山ほどあるでしょうし、寝ても覚めても気になるものが、人気のものとは限りません。
      そもそも、<a className="dfd" href="#dfn-worldWideWeb">Web</a>の情報は普通重要性の低いものです。
      <a className="dfd" href="#dfn-excavate">発掘</a>をするならば、惑わされない心が武器になるかもしれません。
      </p><p>
      『焦りすぎてはいないか』
      <a className="dfd" href="#dfn-excavate">発掘</a>は昔のものほど難しくなるのが普通ですが、場合によっては時間を空けることによって、かえって見つけやすくなることがあります。
      一度に全てを終えてしまおうと思わず、行き詰ったら一休みするのも大切です。
      </p>
      <h3 id="S4-6">連携技で掘り進め！</h3>
      <p>
      これで項目の詳細は解説し終わりました。
      しかし、まだすべての解説が終わったわけではないのです。
      最後に連携について紹介しておこうと思います。
      </p><p>
      簡単な<a className="dfd" href="#dfn-excavate">発掘</a>の場合、フローチャートを上から下へ辿るだけで目的のものへ到達することができます。
      しかし、それが困難なものになると、連携が求められるようになるのです。
      例えば、情報をまとめる段階で、ほんの少ししか手がかりを見つけられなかったとします。
      そんな時には、とりあえず<a className="dfd" href="#dfn-excavate">発掘</a>を進めて、手段を策定したり実際に掘ってみたりするのです。
      すると、出てきたものの中から、新たな手がかりが見つかってくるのです。
      </p><p>
      連携とは、ここではフローチャートを逆流することなのです。
      これを使いこなせるようになれば、<a className="dfd" href="#dfn-excavation">発掘法</a>が身についたと言っていいでしょう。
      </p><p>
      ……これで流れについては全てです。
      さて、冗長な解説を最後まで読んでくださった皆様に、ささやかなプレゼントがあります。
      『<a href="#S7" title="Webリソース発掘法 発掘“ケースバイケース”">発掘“ケースバイケース”</a>』です。
      こちらに、具体的な<a className="dfd" href="#dfn-excavate">発掘</a>の方法を早見表にしてまとめておきました。
      皆様のお役に立てば幸いです。
      </p>
      <h2 id="S5">見つけ出したいこんな手がかり</h2>
      <h3 id="S5-1">手がかりは目標の一部</h3>
      <p>
      題字の通り、手がかりというのは目標の断片そのものです。
      つまり、新たな手がかりを手に入れるたびに発掘は一歩前進するのです。
      ここでは章を三つに分け、それぞれ
      【<a href="#S5-2" title="Webリソース発掘法 目標が必要とする手がかり">“目標”が必要とする手がかり</a>】【<a href="#S5-3" title="Webリソース発掘法 “手がかり”を見つけ出す方法">“手がかり”を見つけ出す方法</a>】【<a href="#S5-4" title="Webリソース発掘法 “情報”から見つけ出せる手がかり">“情報”から見つけ出せる手がかり</a>】
      を書いていきます。では、詳しい使い方を説明しましょう。
      </p><p>
      【<a href="#S5-2" title="Webリソース発掘法 目標が必要とする手がかり">“目標”が必要とする手がかり</a>】
      発掘をする限りは目標が定まっているはずですが、それを見つけるためにはどのような手がかりが重要かを書いているのがこの段です。
      手元に必要な手がかりが足りていない場合は、それを見つけ出すのを最初の目標としてみるといいでしょう。
      </p><p>
      【<a href="#S5-3" title="Webリソース発掘法 “手がかり”を見つけ出す方法">“手がかり”を見つけ出す方法</a>】
      実際に手がかりを探しだすときに、どんな手段で何を見つけ出せばいいかが書いてあります。
      また、それを見つけ出した結果何を発掘できるのかも併せて書いてあります。
      </p><p>
      【<a href="#S5-4" title="Webリソース発掘法 “情報”から見つけ出せる手がかり">“情報”から見つけ出せる手がかり</a>】
      発掘中には目標以外の情報が山のように出てきますが、ここからどれだけ新たな手がかりを見つけ出せるかが発掘の成功にかかわってきます。
      がらくたの中から使えるものを探し出す方法を書いているのがこの段です。
      </p><p>
      三つの段はそれぞれ引用符の中身、つまり【目標】【手がかり】【情報】を見出しに書いてあります。
      つまり、情報について調べたいなら【<a href="#S5-4" title="Webリソース発掘法 “情報”から見つけ出せる手がかり">“情報”から見つけ出せる手がかり</a>】の段を見ればいいのです。
      </p><p>
      それぞれの項目の内容は、下に示すようにまとめています。
      </p>
      <ol>
      <li><span style={{fontWeight: "bolder"}}>内容の分類</span>
      <ol>
      <li className="tit">【内容】　内容の詳細</li>
      <li className="mar">対象の分類　【対象】 【……】 【……】（対象が重要な順）</li>
      <li className="exp">【対象】　対象の詳細</li>
      <li className="exp">【……】　……</li>
      <li className="exp">【……】　……</li>
      <li className="exp">内容に関する考察</li>
      </ol></li></ol>
      <h3 id="S5-2">“目標”が必要とする手がかり</h3>
      <ol><li>
      <h4 id="G-edit">編集形態による区分</h4>
      <ol>
      <li className="tit" id="G-private">【個人編集】　個人サイトやブログ、まとめサイトなど</li>
      <li className="mar">手がかり　<a href="#G-title">【題名】</a> <a href="#G-author">【作者名等】</a> <a href="#G-time">【作成時刻】</a> <a href="#G-contents">【内容】</a> <a href="#G-summary">【要約】</a> <a href="#G-classification">【分類】</a></li>
      <li className="exp"><a href="#G-title">【題名】</a>　題名が特徴的であればそれが決定打となります。</li>
      <li className="exp"><a href="#G-author">【作者名等】</a>　作成者かつ編集者の名前は絞り込みに重要です。</li>
      <li className="exp"><a href="#G-time">【作成時刻】</a>　年単位の大雑把な作成時期でもわかれば役に立ちます。</li>
      <li className="exp"><a href="#G-contents">【内容】</a>　書き手の癖なども発掘の手助けになります。</li>
      <li className="exp"><a href="#G-author">【要約】</a>　特異な内容でない限り役には立たないでしょう。</li>
      <li className="exp"><a href="#G-classification">【分類】</a>　リンク集から探す場合など役に立つことがあります。</li>
      <li className="exp">すべての基本となる形態です。前触れもなく消滅したりするので発掘の機会も多いでしょう。</li>
      </ol><ol>
      <li className="tit" id="G-cooperation">【共同編集】　サークルサイトや掲示板、Wikiなど</li>
      <li className="mar">手がかり　<a href="#G-title">【題名】</a> <a href="#G-author">【作者名等】</a> <a href="#G-time">【作成時刻】</a> <a href="#G-summary">【要約】</a> <a href="#G-contents">【内容】</a> <a href="#G-classification">【分類】</a></li>
      <li className="exp"><a href="#G-title">【題名】</a>　題名が特徴的であればそれが決定打となります。</li>
      <li className="exp"><a href="#G-author">【作者名等】</a>　グループ名がわかっていれば強力な手がかりになります。
      また、個人名しかわからない場合でも、複数いるので数打てば当たるかもしれません。</li>
      <li className="exp"><a href="#G-time">【作成時刻】</a>　年単位の大雑把な作成時期でもわかれば役に立ちます。</li>
      <li className="exp"><a href="#G-author">【要約】</a>　他の情報と組み合わせることで効果が上がります。</li>
      <li className="exp"><a href="#G-contents">【内容】</a>　個人編集の場合よりは重要性が低くなっています。</li>
      <li className="exp"><a href="#G-classification">【分類】</a>　リンク集から探す場合など役に立つことがあります。</li>
      <li className="exp">特徴の掴みにくい形態です。個人と企業の中間的な特徴があります。</li>
      </ol><ol>
      <li className="tit" id="G-company">【企業編集】　企業サイトやSNS、動画共有サイトなど</li>
      <li className="mar">手がかり　<a href="#G-classification">【分類】</a> <a href="#G-contents">【内容】</a> <a href="#G-time">【作成時刻】</a> <a href="#G-title">【題名】</a> <a href="#G-author">【作者名等】</a> <a href="#G-summary">【要約】</a></li>
      <li className="exp"><a href="#G-classification">【分類】</a>　企業編集では何より重要で、
      これに合わせてやり方を大きく変える必要があります。</li>
      <li className="exp"><a href="#G-contents">【内容】</a>　内容によって戦略を変える必要があります。</li>
      <li className="exp"><a href="#G-time">【作成時刻】</a>　精度は良くないものの、多くの場合で利用できます。</li>
      <li className="exp"><a href="#G-title">【題名】</a>　ニュースなど一部の内容で重要です。</li>
      <li className="exp"><a href="#G-author">【作者名等】</a>　SNSなど一部の内容で重要です。</li>
      <li className="exp"><a href="#G-author">【要約】</a>　商品紹介など一部の内容で重要です。</li>
      <li className="exp">方式による差が大きいので、<a href="#G-method">方式による区分</a>を参考にしてください。</li>
      </ol>
      </li><li>
      <h4 id="G-method">方式による区分</h4>
      <ol>
      <li className="tit" id="G-html">【生html】　特に何のひねりもなく直接html文書が置いてあるページ。</li>
      <li className="mar">手がかり　<a href="#G-title">【題名】</a> <a href="#G-contents">【内容】</a> <a href="#G-author">【作者名等】</a> <a href="#G-summary">【要約】</a> <a href="#G-time">【作成時刻】</a> <a href="#G-classification">【分類】</a></li>
      <li className="exp"><a href="#G-title">【題名】</a>　題名が特徴的であればそれが決定打となります。</li>
      <li className="exp"><a href="#G-contents">【内容】</a>　生htmlの場合、変化が起きにくいので特に重要です。</li>
      <li className="exp"><a href="#G-author">【作者名等】</a>　作者のページを見つけ出せば、新たな手がかりが手に入ります。</li>
      <li className="exp"><a href="#G-time">【作成時刻】</a>　年単位の大雑把な作成時期でもわかれば役に立ちます。</li>
      <li className="exp"><a href="#G-author">【要約】</a>　最近はカテゴリ検索が下火なので利用しにくい手がかりです。</li>
      <li className="exp"><a href="#G-classification">【分類】</a>　上に同じ。</li>
      <li className="exp">内容の大きく変化しない単純な形態です。Wayback Machineが役に立つでしょう。</li>
      </ol><ol>
      <li className="tit" id="G-blog">【ブログ】　情報が時系列で記録されるページの一形態。</li>
      <li className="mar">手がかり　<a href="#G-author">【作者名等】</a> <a href="#G-time">【作成時刻】</a> <a href="#G-title">【題名】</a> <a href="#G-contents">【内容】</a> <a href="#G-summary">【要約】</a> <a href="#G-classification">【分類】</a></li>
      <li className="exp"><a href="#G-author">【作者名等】</a>　ブログを探し出す時などにまず必要となる手がかりです。</li>
      <li className="exp"><a href="#G-time">【作成時刻】</a>　日時からURLを予想したり色々な役に立ちます。</li>
      <li className="exp"><a href="#G-classification">【分類】</a>　記事に貼ってあるタグが役に立つかもしれません。</li>
      <li className="exp"><a href="#G-title">【題名】</a>　題名はあまり重要視されないので、特徴的なものでも役に立たないことがあります。</li>
      <li className="exp"><a href="#G-contents">【内容】</a>　ブログでは内容の差異が小さくなりがちなので、利用しにくくなっています。</li>
      <li className="exp"><a href="#G-author">【要約】</a>　トラックバックなどから情報を引き出せる可能性もあります。</li>
      <li className="exp">記事が見えなくなっても慌てないでページを探せば、普通に残っている場合があります。</li>
      </ol><ol>
      <li className="tit" id="G-bbs">【掲示板】　利用者同士のやりとりそのもので成り立つページの一形態。</li>
      <li className="mar">手がかり　<a href="#G-time">【作成時刻】</a> <a href="#G-title">【題名】</a> <a href="#G-contents">【内容】</a> <a href="#G-summary">【要約】</a> <a href="#G-classification">【分類】</a> <a href="#G-author">【作者名等】</a></li>
      <li className="exp"><a href="#G-time">【作成時刻】</a>　投稿の日時が残りやすく、過去ログのURLも日付ベースのことが多いので、時期の特定に役立ちます。</li>
      <li className="exp"><a href="#G-title">【題名】</a>　スレッドタイトルが特徴的でも、似た名前のスレッドが大抵無数にあるので根気がいります。</li>
      <li className="exp"><a href="#G-contents">【内容】</a>　特徴的なレスや話題が手がかりになります。その前後の流れも含めて検証してください。</li>
      <li className="exp"><a href="#G-summary">【要約】</a>　どんな話題のスレだったかを語れるなら、まとめサイトへ等の転載記事に突き当たる可能性があります。</li>
      <li className="exp"><a href="#G-classification">【分類】</a>　どの板・カテゴリのものかがわかれば、過去ログ倉庫を絞り込めます。</li>
      <li className="exp"><a href="#G-author">【作者名等】</a>　コテハンやトリップがあれば手がかりになりますが、発言の量も大抵多いため手がかりとしては弱めです。</li>
      <li className="exp">dat落ちしても、過去ログ倉庫やまとめサイト、魚拓に残っていることが多いので、諦めないこと。</li>
      </ol>
<ol>
      <li className="tit">【チャット】　利用者同士の即時的なやりとりで成り立つページの一形態。</li>
      <li className="mar">手がかり　<a href="#G-time">【作成時刻】</a> <a href="#G-author">【作者名等】</a> <a href="#G-contents">【内容】</a> <a href="#G-title">【題名】</a> <a href="#G-summary">【要約】</a> <a href="#G-classification">【分類】</a></li>
      <li className="exp"><a href="#G-time">【作成時刻】</a>　即時的なやりとりなので、いつのものかは非常に重要です。</li>
      <li className="exp"><a href="#G-author">【作者名等】</a>　参加者のハンドルは、基本的には補助的な情報です。</li>
      <li className="exp"><a href="#G-contents">【内容】</a>　その場限りの会話が多く、急に話題が変わっている可能性もあるので結局すべて読むことになりがちです。</li>
      <li className="exp"><a href="#G-title">【題名】</a>　ページに題名が付かないことも多く、期待しにくい手がかりです。</li>
      <li className="exp"><a href="#G-summary">【要約】</a>　会話の流れをしっかりとまとめたうえで、それを踏まえて該当範囲のログをひたすら読みましょう。</li>
      <li className="exp"><a href="#G-classification">【分類】</a>　会話の雰囲気が似ているというようなところが捜索範囲の決め手となりやすいです。</li>
      <li className="exp">ログがそもそも残されにくく、発掘の難易度は高い部類。</li>
      </ol><ol>
      <li className="tit">【Wiki】　利用者が情報を書き換えることで成り立つページの一形態。</li>
      <li className="mar">手がかり　<a href="#G-title">【題名】</a> <a href="#G-time">【作成時刻】</a> <a href="#G-contents">【内容】</a> <a href="#G-classification">【分類】</a> <a href="#G-author">【作者名等】</a> <a href="#G-summary">【要約】</a></li>
      <li className="exp"><a href="#G-title">【題名】</a>　項目名がそのまま題名にあたり、明確なら強力な手がかりです。</li>
      <li className="exp"><a href="#G-time">【作成時刻】</a>　版が積み重なるので、いつの版かで内容が変わる点に注意しましょう。</li>
      <li className="exp"><a href="#G-contents">【内容】</a>　編集履歴に過去の版が残っていることが多く、消えても遡れることが多いですが、検索にヒットするかは別問題です。</li>
      <li className="exp"><a href="#G-classification">【分類】</a>　カテゴリやテンプレートから関連項目をたどってみてください。</li>
      <li className="exp"><a href="#G-author">【作者名等】</a>　編集者は多数のため、単独では絞り込みにくい手がかりです。</li>
      <li className="exp"><a href="#G-summary">【要約】</a>　各版の編集コメントが、変遷を追う助けになります。</li>
      <li className="exp">版管理のおかげで、消えたように見えても履歴や過去版に残っていることが多い形態です。</li>
      </ol><ol>
      <li className="tit">【その他】　上記の方式に当てはまらないページ。</li>
      <li className="exp">まずは形態を見極め、いちばん近い区分を参照してください。手がかりの効き方は、その形態に準じます。</li>
      </ol>
      </li><li>
      <h4>内容による区分</h4>
      <ol>
      <li className="tit">【文章】　文章を主体とするページ。</li>
      <li className="mar">手がかり　<a href="#G-contents">【内容】</a> <a href="#G-title">【題名】</a> <a href="#G-author">【作者名等】</a> <a href="#G-summary">【要約】</a> <a href="#G-time">【作成時刻】</a> <a href="#G-classification">【分類】</a></li>
      <li className="exp"><a href="#G-contents">【内容】</a>　そのまま検索にかければ引用や写しに当たれます。特徴的な一節や言い回しが大きな手がかりとなります。</li>
      <li className="exp"><a href="#G-title">【題名】</a>　題名が特徴的なら決定打になり得ます。</li>
      <li className="exp"><a href="#G-author">【作者名等】</a>　安定して重要な手がかりです。</li>
      <li className="exp"><a href="#G-summary">【要約】</a>　先人が言及していれば、その情報に突き当たる可能性があります。</li>
      <li className="exp"><a href="#G-time">【作成時刻】</a>　いつ書かれたかで、探す時期の見当がつきます。</li>
      <li className="exp"><a href="#G-classification">【分類】</a>　ジャンルがわかれば、収録先やリンク集を絞れます。</li>
      <li className="exp">一節の引用が効きやすく、比較的たどりやすい形態です。</li>
      </ol><ol>
      <li className="tit">【画像】　画像を主体とするページ。</li>
      <li className="mar">手がかり　<a href="#G-contents">【内容】</a> <a href="#G-author">【作者名等】</a> <a href="#G-time">【作成時刻】</a> <a href="#G-title">【題名】</a> <a href="#G-classification">【分類】</a> <a href="#G-summary">【要約】</a></li>
      <li className="exp"><a href="#G-contents">【内容】</a>　見た目の特徴が手がかりとなります。<a className="dfd" href="#dfn-imageSearch">画像検索</a>で同じ・似た画像を探してみてもよいです。</li>
      <li className="exp"><a href="#G-author">【作者名等】</a>　作者や撮影者は貴重な文字情報であり、捜索の軸となり得ます。</li>
      <li className="exp"><a href="#G-time">【作成時刻】</a>　いつの画像かで、探す時期が絞れます。</li>
      <li className="exp"><a href="#G-title">【題名】</a>　ファイル名やキャプションが手がかりになることがあります。</li>
      <li className="exp"><a href="#G-classification">【分類】</a>　どんなジャンルかで、収録先の見当がつきます。</li>
      <li className="exp"><a href="#G-summary">【要約】</a>　何が描かれているかを言葉にできれば、検索の助けになります。</li>
      <li className="exp">画像検索という専用の武器があるぶん、動画よりは糸口をつかみやすい形態です。</li>
      </ol><ol>
      <li className="tit">【動画】　動画を主体とするページ。</li>
      <li className="mar">手がかり　<a href="#G-contents">【内容】</a> <a href="#G-title">【題名】</a> <a href="#G-author">【作者名等】</a> <a href="#G-time">【作成時刻】</a> <a href="#G-classification">【分類】</a> <a href="#G-summary">【要約】</a></li>
      <li className="exp"><a href="#G-contents">【内容】</a>　印象的な一場面や流れる曲が手がかりとなり得ます。そのため、フレームを<a className="dfd" href="#dfn-imageSearch">画像検索</a>にかけたり、曲を特定したりすることも試すべきです。</li>
      <li className="exp"><a href="#G-title">【題名】</a>　題名が特徴的なら強力です。ただし、本体はなかなか手に入らず、存在した痕跡だけが残っているというのが普通です。</li>
      <li className="exp"><a href="#G-author">【作者名等】</a>　投稿者をたどれば、関連動画や別投稿を見つけられます。別投稿先では現役の動画である可能性もあります。</li>
      <li className="exp"><a href="#G-time">【作成時刻】</a>　投稿時期がわかれば、範囲を狭められます。</li>
      <li className="exp"><a href="#G-classification">【分類】</a>　タグやカテゴリは手がかりとなりますが、対象が膨大である割に取ろうとなる可能性が高いです。</li>
      <li className="exp"><a href="#G-summary">【要約】</a>　どんな動画かを語れれば、特定スレなどと突き合わせられます。</li>
      <li className="exp">残すための労力が大きいため、どこにも残っていない可能性が非常に高い形式です。手がかりも切り口によって無数にあり選択が難しいです。</li>
      </ol>
      </li></ol>
      <h3 id="S5-3">“手がかり”を見つけ出す方法</h3>
<p>ここでは、目標を探すのに欲しい手がかりが手元に足りないとき、その手がかり自体をどうやって見つけ出すか、そして見つけ出せた結果として何を掘れるようになるかを、手がかりの種類ごとに書いていきます。</p>
<h4>内容に関連する情報</h4>
<h5 id="G-title">【題名】</h5>
<p>もっとも強力な手がかりですが、正確に思い出せないことも多い。うろ覚えなら、記憶にある断片を<a className="dfd" href="#dfn-searchEngine">検索エンジン</a>にかける、当時のリンク集や<a className="dfd" href="#dfn-summarySite">まとめサイト</a>の一覧を眺める、同じものを探した先人の書き込み（「名前が思い出せないゲームを教えてくれるスレ」など）を頼る、といった手が使えます。一部でも正しい題名がわかれば、それだけで発掘がほぼ終わってしまうことも珍しくありません。</p>
<h5 id="G-summary">【要約】</h5>
<p>どんなものだったかという大まかな概要。題名がわからなくても、要約さえ語れれば立派な手がかりです。「こういうものを探している」と他人に説明できる形にまとめておくと、先人の書き込みと突き合わせたり、リンク集の紹介文と照合したりするのに役立ちます。単独では弱いので、ほかの手がかりと組み合わせて使いましょう。</p>
<h5 id="G-contents">【内容】</h5>
<p>具体的な中身の記憶——登場人物、特徴的なセリフや場面、独自の仕様など。ありふれた要約より、こうした固有の断片のほうが検索では強力です。細部を一つでも正確に覚えていれば、それを別の<a className="dfd" href="#dfn-searchWord">検索語句</a>と合わせることで絞り込めることがありますし、候補が見つかったときに同一性を確かめる決め手にもなります。</p>
<h5 id="G-classification">【分類】</h5>
<p>どんなジャンル・カテゴリに属していたか。記事のタグ、リンク集の区分、当時のカテゴリ検索の分類などがこれにあたります。分類がわかれば、検索が効かない古い作品でも、当時のカテゴリ一覧を直接たどって探せます。ただし年代ごとに分類の切り方が変わる（統合されていたものが後年に分かれる等）ので、当時の区分が異なる場合は柔軟に調整しましょう。</p>
<h4>形成に関連する情報</h4>
<h5 id="G-time">【作成時刻】</h5>
<p>いつ作られた・公開されたか。大雑把な年単位でも十分役に立ちます。<a className="dfd" href="#dfn-URL">URL</a>に含まれる日付、著作権表示の年、当時の出来事への言及、<a className="dfd" href="#dfn-waybackMachine">Wayback Machine</a>の最初の<a className="dfd" href="#dfn-compile">収集</a>時期などから推定できます。時期が絞れれば、Waybackをどの年で見るかを決められますし、年代別のカタログ一覧を狙い撃ちにできます。</p>
<h5 id="G-author">【作者名等】</h5>
<p>作った人・グループの名前。作品そのものの表記、関連作品のクレジット、当時の仲間内での言及などから拾えます。作者名がわかれば、作者の別のページを見つけ出し、そこから配布元や新たな手がかりへと<a href="#S4-6" title="Webリソース発掘法 連携技で掘り進め！">連携技</a>でたぐっていけます。一つの作品が消えていても、作者を軸にすると芋づる式に掘れることがあります。</p>
<h5 id="G-way">【作成手段】</h5>
<p>どんな道具・環境で作られたか。RPGツクールのようなツール、特定の作成ソフト、規格などです。作成手段がわかると、その道具に固有の配布経路——たとえばツクール作品を大量に収録した雑誌付録の<a className="dfd" href="#dfn-capacity">CD</a>-Rなど——に見当がつきます。ダウンロードが死んでいても、そうした収録物の中で生き延びていることは珍しくありません。</p>
<h5>【規格形式】</h5>
<p>ファイルの形式——<a className="dfd" href="#dfn-webPage">html</a>か実行ファイルか、圧縮形式（lzh／zip）か、画像・動画の形式か。形式によって、どこに生き残りやすいかが変わります。実行ファイルやアーカイブは収録CDに、画像は<a className="dfd" href="#dfn-imageboard">画像掲示板</a>やまとめに、というように、探すべき場所の見当をつけるのに使えます。そして、意外と盲点ですが検索語としても使えます。</p>
<h3 id="S5-4">“情報”から見つけ出せる手がかり</h3>
<p>発掘の途中には、目標そのもの以外の情報が山のように出てきます。そのがらくたの中から、新たな手がかりをどれだけ拾えるか。ここでは、出くわした情報の種類ごとに、そこから引き出せる手がかりを書いていきます。</p>
<h4>方式による区分</h4>
<h5>【生html】</h5>
<p>生htmlのページに行き当たったら、そこから多くの手がかりを引き出せます。ソースに残る作成日時やメタ情報、コメント、そして何より張られた<a className="dfd" href="#dfn-URL">リンク</a>——リンク先をたどれば作者の別ページや関連サイトに届きます。変化の少ない形式なので、<a className="dfd" href="#dfn-waybackMachine">Wayback Machine</a>に残ってさえいれば当時の姿をほぼそのまま読めます。</p>
<h5>【掲示板】</h5>
<p>掲示板の書き込みからは、投稿の日時、コテハンやトリップ、引用やアンカーによる話題のつながりが拾えます。誰かが目標について触れていれば、その前後のやりとりから作者や配布元の情報が芋づる式に出てくることもあります。</p>
<h4>内容による区分</h4>
<h5>【文章】</h5>
<p>文章そのものからは、特徴的な言い回しや誤字の癖、固有名詞が手がかりになります。印象的な一節をそのまま<a className="dfd" href="#dfn-search">検索</a>にかければ、それを引用したページや、別の場所に残った写しに当たることがあります。</p>
<h5>【画像】</h5>
<p>画像からは、<a className="dfd" href="#dfn-imageSearch">画像検索</a>（同じ・似た画像を探す）、透かしや署名、EXIFなどの付随情報が手がかりになります。撮影者や初出をたどれれば、そこから芋づる式に掘り進められます。</p>
<h5>【動画】</h5>
<p>動画からは、印象的な一場面、流れている音や曲、投稿時の情報が手がかりになります。フレームを<a className="dfd" href="#dfn-imageSearch">画像検索</a>にかけたり、<a className="dfd" href="#dfn-videoSearch">動画検索</a>で似たものを探したり、曲を特定したりすることで、出所へたどり着けることがあります。</p>
      <h2 id="S6">どんな道具が使えるのか</h2>
      <h3 id="S6-1">手段は星の数</h3>
      <p>
      ここでは<a className="dfd" href="#dfn-excavate">発掘</a>において実際に使える手段を紹介していきます。
      一つ 〃 の手段についてより詳しく知りたいと思った時は、<a className="dfd" href="#dfn-worldWideWeb">Web</a>上に存在する数多の解説<a className="dfd" href="#dfn-webPage">ページ</a>を参考にしてください。
      </p>
      <h3 id="S6-2"><a className="dfd" href="#dfn-searchEngine">検索エンジン</a></h3>
      <p>
      <a className="dfd" href="#dfn-excavate">発掘</a>の大黒柱で全ての基本。
      これを使いこなして初めてスタートラインに立ったことになる。
      最低限の使い方はシンプルだが、本が一冊書けるほど奥は深い。
      そして、実際にたくさんのテキストが存在する。
      </p>
      <h4 id="S6-2-1">基本の使い方</h4>
      <p>
      文字列を入力すると、<a className="dfd" href="#dfn-searchResult">検索結果</a>として入力文字列を含む<a className="dfd" href="#dfn-webPage">Webページ</a>が表示される。
      ただし、<a className="dfd" href="#dfn-searchEngine">検索エンジン</a>があらかじめ情報を<a className="dfd" href="#dfn-compile">収集</a>した<a className="dfd" href="#dfn-webPage">ページ</a>しか、<a className="dfd" href="#dfn-searchResult">検索結果</a>には表示されない。
      文字列を元に<a className="dfd" href="#dfn-search">検索</a>を行う<a className="dfd" href="#dfn-searchEngine">検索エンジン</a>は、最低限これだけの機能は持っている。
      <a className="dfd" href="#dfn-searchEngine">検索エンジン</a>によっては、文字列をいくつかに分割し『<a className="dfd" href="#dfn-refineSearch">絞り込み検索</a>』として扱う場合がある。
      また、“その<a className="dfd" href="#dfn-webPage">ページ</a>へのリンクに入力文字列が含まれる”<a className="dfd" href="#dfn-webPage">ページ</a>が表示されることもある。
      <em className="exam">出雲大社について知りたいとき　『<kbd>出雲大社</kbd>』</em>
      </p><p className="sup">
      現在では<a className="dfd" href="#dfn-worldWideWeb">Web</a>利用者の97%が利用するという噂の<a className="dfd" href="#dfn-searchEngine">検索エンジン</a>。
      基本は最初の一行に集約されるのですが、それだけの知識で必要な情報を引き出すのは難しいかもしれません。
      次の段からは、これを使いこなすための情報が並んでいます。
      </p>
      <h4 id="S6-2-2">詳しい<a className="dfd" href="#dfn-search">検索</a>方法</h4>
      <p>
      <a className="dfd" href="#dfn-searchWord">検索語句</a>に演算子を加えることによって、通常とは違う方法で<a className="dfd" href="#dfn-search">検索</a>を行うことが出来る場合がある。
      また、後述する<a className="dfd" href="#dfn-searchOption">検索オプション</a>によってこれを達成している<a className="dfd" href="#dfn-searchEngine">検索エンジン</a>もある。
      </p><p>
      『<a className="dfd" href="#dfn-refineSearch">絞り込み検索</a>』二つ以上の文字列を入力し、その全てが含まれる<a className="dfd" href="#dfn-webPage">ページ</a>を<a className="dfd" href="#dfn-search">検索</a>する。
      スペースを目印にその前後を別の文字列として扱う場合が多い。
      <em className="exam">大神神社に供えられている卵について知りたいとき　『<kbd>大神神社 卵</kbd>』</em>
      </p><p>
      『マイナス<a className="dfd" href="#dfn-search">検索</a>』指定した文字列が含まれる<a className="dfd" href="#dfn-webPage">ページ</a>を<a className="dfd" href="#dfn-searchResult">検索結果</a>から除外する。
      マイナスを目印に直後の文字列を対象とする場合が多い。
      <em className="exam">『気多大社』の結果から公式<a className="dfd" href="#dfn-webPage">ページ</a>を除きたいとき　『<kbd>気多大社 -www.keta.jp</kbd>』</em>
      </p><p>
      『フレーズ<a className="dfd" href="#dfn-search">検索</a>』指定した文字列を、ひとつながりの文字列であると明示する。
      二つのダブルクオーテーションで囲まれた文字列を対象とする場合が多い。
      <em className="exam">『気多本宮』を気多と本宮の二語に分けられたくないとき　『<kbd>"気多本宮"</kbd>』</em>
      </p><p className="sup">
      知っていないと困る三つの拡張機能です。
      基本的にはすべて<a className="dfd" href="#dfn-refineSearch">絞り込み検索</a>のために使用される機能で、<a className="dfd" href="#dfn-searchResult">検索結果</a>が足りない場合はどうしようもありません。
      ただ、そんな場合は別の単語を試してみるという手もあります。
      </p>
      <h4 id="S6-2-3"><a className="dfd" href="#dfn-searchOption">検索オプション</a></h4>
      <p>
      <a className="dfd" href="#dfn-search">検索</a>前に追加設定を選択することによって、通常とは違う方法で<a className="dfd" href="#dfn-search">検索</a>を行うことが出来る場合がある。
      また、前述した演算子によってこれを達成している<a className="dfd" href="#dfn-searchEngine">検索エンジン</a>もある。
      </p><p>
      『言語設定』特定の言語で記述された<a className="dfd" href="#dfn-webPage">ページ</a>を<a className="dfd" href="#dfn-search">検索</a>する。<br />
      『日付設定』特定の時間内に<a className="dfd" href="#dfn-compile">収集</a>された<a className="dfd" href="#dfn-webPage">ページ</a>を<a className="dfd" href="#dfn-search">検索</a>する。<br />
      『<a className="dfd" href="#dfn-domain">ドメイン</a>内<a className="dfd" href="#dfn-search">検索</a>』特定の<a className="dfd" href="#dfn-domain">ドメイン</a>内に限定して<a className="dfd" href="#dfn-search">検索</a>する。<br />
      『※セーフサーチ』成人向けコンテンツを含む<a className="dfd" href="#dfn-webPage">ページ</a>を<a className="dfd" href="#dfn-searchResult">検索結果</a>から除外する。<br />
      </p><p className="sup">
      使いこなせると便利な三つの拡張機能です。<br />
      ※セーフサーチはデフォルトでオンになっている場合が多いのですが、関係のない<a className="dfd" href="#dfn-webPage">ページ</a>まで除外しがちなので、事情がなければオフにしてください。
      </p>
      <h4 id="S6-2-4"><a className="dfd" href="#dfn-search">検索</a>種別</h4>
      <p>
      通常<a className="dfd" href="#dfn-worldWideWeb">Web</a> <a className="dfd" href="#dfn-search">検索</a>では<a className="dfd" href="#dfn-searchResult">検索結果</a>として<a className="dfd" href="#dfn-webPage">Webページ</a>が表示されるが、画像など他の情報を<a className="dfd" href="#dfn-searchResult">検索結果</a>に指定できる場合がある。
      多くの場合、<a className="dfd" href="#dfn-search">検索</a> <a className="dfd" href="#dfn-webPage">ページ</a>に設置されたリンクから使用できる。
      </p><p>
      『<a className="dfd" href="#dfn-imageSearch">画像検索</a>』文字列を入力すると、<a className="dfd" href="#dfn-searchResult">検索結果</a>として画像を一覧表示する。
      <a className="dfd" href="#dfn-webPage">Webページ</a>で画像に付けられた題名や見出し、隣接する文章、もしくはリンク元の情報をもとに<a className="dfd" href="#dfn-search">検索</a>している。
      </p><p>
      『<a className="dfd" href="#dfn-videoSearch">動画検索</a>』文字列を入力すると、<a className="dfd" href="#dfn-searchResult">検索結果</a>として動画を一覧表示する。
      YouTubeなどの動画ページ内を<a className="dfd" href="#dfn-search">検索</a>し、重要な部分に<a className="dfd" href="#dfn-searchWord">検索語句</a>が存在する順番に並べられる。
      </p><p>
      その他にも地図<a className="dfd" href="#dfn-search">検索</a>やニュース<a className="dfd" href="#dfn-search">検索</a>、ブログ<a className="dfd" href="#dfn-search">検索</a>などが存在するが、上記の<a className="dfd" href="#dfn-search">検索</a>とほとんど同じ解説となるので省略する。
      </p><p className="sup">
      さまざまな<a className="dfd" href="#dfn-search">検索</a>対象を切り替えることが出来ます。
      しかし、画像を探すのならば<a className="dfd" href="#dfn-imageSearch">画像検索</a>などとは考えず、場合によって都合の良い<a className="dfd" href="#dfn-search">検索</a>を利用してください。
      </p>
      <h4 id="S6-2-5"><a className="dfd" href="#dfn-searchEngine">検索エンジン</a>の選択</h4>
      <p>
      <a className="dfd" href="#dfn-searchEngine">検索エンジン</a>には、ロボット型とディレクトリ型という二つのタイプがあるが、現在はほとんどロボット型が主体となっている。
      二つの違いは<a className="dfd" href="#dfn-webPage">Webページ</a> <a className="dfd" href="#dfn-compile">収集</a>の方法で、ロボット型はプログラムが自動的に<a className="dfd" href="#dfn-compile">収集</a>しているが、ディレクトリ型は人間が手作業で行っている。
      </p><p>
      <a className="dfd" href="#dfn-worldWideWeb">Web</a>には様々な<a className="dfd" href="#dfn-searchEngine">検索エンジン</a>が存在するが、当然それぞれ特徴が異なる。
      ここではそのうちの三つを紹介する。
      </p><p>
      『<a className="dfd" href="#dfn-google">Google</a>』世界の<a className="dfd" href="#dfn-searchEngine">検索エンジン</a>戦争を制した王者。ロボット型。
      これ一つでほとんど全ての<a className="dfd" href="#dfn-webPage">ページ</a>をカバーすることが出来るので、他のエンジンを使う必要性は無いのかもしれない。
      </p><p>
      『<a className="dfd" href="#dfn-yahoo">Yahoo!</a>』日本でもっとも使われている<a className="dfd" href="#dfn-searchEngine">検索エンジン</a>。
      昔はディレクトリ型であったが、現在はロボット型が主体。
      </p><p>
      『Bing』マイクロソフト社製<a className="dfd" href="#dfn-searchEngine">検索エンジン</a>。旧Liveサーチ。ロボット型。
      IEを使っていると猛烈にプッシュしてくる。シェアはまだ小さい。
      </p>
      <h3 id="S6-3"><a className="dfd" href="#dfn-internetArchive">Internet Archive</a> <a className="dfd" href="#dfn-waybackMachine">Wayback Machine</a></h3>
      <p>
      <a className="dfd" href="#dfn-excavate">発掘</a>において現在もっとも重要なサービス。
      『<a className="dfd" href="#dfn-internetArchive">Internet Archive</a>』は研究者等のために<a className="dfd" href="#dfn-webPage">Webページ</a>の図書館を作らんとする団体。
      1996年から<a className="dfd" href="#dfn-webPage">Webページ</a>のコピーを<a className="dfd" href="#dfn-compile">収集</a>し続けている。
      そして『<a className="dfd" href="#dfn-waybackMachine">Wayback Machine</a>』は、その膨大なデータを元に<a className="dfd" href="#dfn-URL">URL</a>から<a className="dfd" href="#dfn-compile">収集</a>時点の<a className="dfd" href="#dfn-webPage">Webページ</a>等を見ることができるもの。
      これを使わずして諦めることはできない。
      </p>
      <h4 id="S6-3-1">基本の使い方</h4>
      <p>
      <a className="dfd" href="#dfn-URL">URL</a>を入力すると、<a className="dfd" href="#dfn-searchResult">検索結果</a>として過去、<a className="dfd" href="#dfn-compile">収集</a>時点でそこに存在した<a className="dfd" href="#dfn-webPage">Webページ</a>が日付で一覧表示される。
      このとき<a className="dfd" href="#dfn-searchResult">検索結果</a>件数は、<a className="dfd" href="#dfn-internetArchive">Internet Archive</a> が<a className="dfd" href="#dfn-compile">収集</a>を行った回数である。
      また、前回<a className="dfd" href="#dfn-compile">収集</a>と比較して<a className="dfd" href="#dfn-webPage">Webページ</a>が変化していれば、日付の後にアスタリスク(*)が表示される。
      <em className="exam">過去の米<a className="dfd" href="#dfn-google">Google</a> <a className="dfd" href="#dfn-topPage">トップページ</a>　『<kbd>http://google.com</kbd>』</em>
      </p><p className="sup">
      <a className="dfd" href="#dfn-excavate">発掘</a>をするのならば使わないわけにはいかないサービス。
      簡単な<a className="dfd" href="#dfn-excavate">発掘</a>の場合<a className="dfd" href="#dfn-URL">URL</a>をここに放り込むだけで終わる場合もあります。
      無料なのでありがたく使わせてもらいましょう。
      ちなみに寄付も受け付けているようです。
      </p>
      <h4 id="S6-3-2"><a className="dfd" href="#dfn-searchResult">検索結果</a>が0件の場合</h4>
      <p>
      <a className="dfd" href="#dfn-internetArchive">Internet Archive</a> があらかじめ情報を<a className="dfd" href="#dfn-compile">収集</a>していないか、情報がまだ反映されていないかのどちらか。
      現在 <a className="dfd" href="#dfn-internetArchive">Internet Archive</a> が情報を<a className="dfd" href="#dfn-compile">収集</a>してから <a className="dfd" href="#dfn-waybackMachine">Wayback Machine</a> にそれが反映されるまでには半年以上の時間が必要である。
      </p><p>
      どちらの場合でも『Click here to search for all pages on <var><a className="dfd" href="#dfn-domain">ドメイン</a>名</var>』という項目が表示され、選択すると入力した<a className="dfd" href="#dfn-URL">URL</a>と<a className="dfd" href="#dfn-domain">ドメイン</a>部分が同じで、すでに反映されている<a className="dfd" href="#dfn-webPage">ページ</a>が一覧表示される。
      </p><p>
      もちろん、その結果も0件だということもある。
      </p>
      <h4 id="S6-3-3"><a className="dfd" href="#dfn-searchResult">検索結果</a>の使い方</h4>
      <p>
      検索結果の日付を選択すると、検索したURLにその時点で存在したWebページ（などのファイル）を見ることが出来る。
      ページ内のリンクは全てWayback Machine内へのものに置き換えられており、選択すると存在する中で最も収集時点の近い<a className="dfd" href="#dfn-archive">アーカイブ</a>が呼び出される。
      </p><p className="sup">
      リンクの置き換えによって、
      </p>
      <h2 id="S7"><a className="dfd" href="#dfn-excavate">発掘</a>“ケースバイケース”</h2>
      <p>『<a href="#S7-" title="Webリソース発掘法 発掘ケースバイケースの使い方">発掘ケースバイケースの使い方</a>』はこちら。</p>
      <h3 id="S7-1">こんなときどうすればいいの？</h3>
<p>探している問題に近いものを選んでいけば、解決の糸口にたどり着けます。欲しい項目があれば『AntennaJane掲示板』へどうぞ。</p>
<ul>
<li><a href="#S7-2" title="Webリソース発掘法 目標設定に関する問題">何を探していいかがわかりません。</a></li>
<li><a href="#S7-3" title="Webリソース発掘法 手がかりに関する問題">発掘の手がかりが足りません。</a></li>
<li><a href="#S7-4" title="Webリソース発掘法 手段に関する問題">どんな方法で探せばいいのでしょうか。</a></li>
<li><a href="#S7-5" title="Webリソース発掘法 効率に関する問題">発掘を早く終わらせたいです。</a></li>
<li><a href="#S7-6" title="Webリソース発掘法 その他の問題">その他</a></li>
</ul>
<h3 id="S7-2">目標設定に関する問題</h3>
<dl className="ndl">
<dt>どんなものが探せますか。</dt>
<dd>一度Webに公開されたものであればなんでも探すことができますが、一般に人気があって低<a className="dfd" href="#dfn-capacity">容量</a>のものが見つけやすいです。人気があれば<a className="dfd" href="#dfn-mirrorSite">ミラーサイト</a>が残っている可能性が高まりますし、低<a className="dfd" href="#dfn-capacity">容量</a>であれば何かのついでに残されていることが多いです。ただし、小説は何故か残りづらいです。</dd>
<dt>特に探すものがなくて。</dt>
<dd>探すものがないのであれば、それは何よりなのでは……？　とはいえ、<a className="dfd" href="#dfn-excavate">発掘</a>を知らないと発掘で解決すべきという発想にならないのも事実。昔よく見ていたのに消えた<a className="dfd" href="#dfn-webSite">Webサイト</a>、記憶の片隅にのみ残ったゲーム。そういったものを発掘してみると良いでしょう。腕試しということであれば、出所不明となっているネットミームなどはいかがですか。</dd>
</dl>
<h3 id="S7-3">手がかりに関する問題</h3>
<dl className="ndl">
<dt>どんなものが手がかりになりますか。</dt>
<dd>基本的には、見つけたいものをどれだけありありと想像できるかにかかっています。想像できれば、そこに含まれる要素が手掛かりとして使えることになります。想像できないなら似たものをいくつか参考にすることで、構造が見えてくると思います。具体的な手がかりは『<a href="#S5" title="Webリソース発掘法 見つけ出したいこんな手がかり">見つけ出したいこんな手がかり</a>』にまとめました。</dd>
<dt>目標のことがほとんどわかりません。</dt>
<dd>うろ覚えの断片で<a className="dfd" href="#dfn-search">検索</a>してみましょう。なるべくありふれていない、目標に固有の単語で検索できればよりよいです。検索にて近いものが見つかれば、そこに含まれる単語を参考に、<a className="dfd" href="#dfn-refineSearch">絞り込み検索</a>で<a className="dfd" href="#dfn-searchWord">検索語句</a>を洗練させていってください。同じものを探した先人の書き込みに、ひょっこり当たることもあります。</dd>
<dt>在りし日の姿が記憶にあります。</dt>
<dd>見た目情報は非常に重要ですが、画像形式でない場合は引きずられすぎないように。<a href="#S6-3" title="Webリソース発掘法 Internet Archive Wayback Machine">Wayback Machine</a>にて<a className="dfd" href="#dfn-secure">確保</a>されたページや<a className="dfd" href="#dfn-mirrorSite">ミラーサイト</a>は見た目が大きく異なることがあります。また逆に、見た目はすごく似ているのに内容だけが違うという場合は同一ページ内に存在するのにリンクが張られていない、昔あったが削除されているなどのパターンを疑う必要があります。</dd>
<dt>目標の一部が手元にあります。</dt>
<dd>非常に重要な手がかりです。まずはそれを<a className="dfd" href="#dfn-secure">確保</a>するところから始めてください。油断して失われてしまうと二度と手に入らないかもしれません。その後<a href="#S4-6" title="Webリソース発掘法 連携技で掘り進め！">連携技</a>を駆使して作者や配布元をたぐっていきましょう。</dd>
<dt>目標については完全にわかっています。</dt>
<dd>完全にわかっているのに発掘する必要があるのですか……？　いえ、実際に掲載されていたのかを確かめたいなど発掘する理由は様々ありますね。完全にわかっている状態から発掘するのであれば、手がかりは山ほどあるので、あとは今すぐ発掘を始めることが重要です。時間が経てば状況が変わり見つからなくなる可能性が高まります。逆に時間を空けることで見つかるようになることもあります。</dd>
</dl>
<h3 id="S7-4">手段に関する問題</h3>
<dl className="ndl">
<dt>どんな手段がありますか。</dt>
<dd>山ほどありますが、基本的には<a href="#S6-2" title="Webリソース発掘法 検索エンジン">検索エンジン</a>と<a href="#S6-3" title="Webリソース発掘法 Internet Archive Wayback Machine">Wayback Machine</a>のふたつを駆使することが重要になります。『<a href="#S6" title="Webリソース発掘法 どんな道具が使えるのか">どんな道具が使えるのか</a>』にまとめてあります。</dd>
</dl>
<h3 id="S7-5">効率に関する問題</h3>
<dl className="ndl">
<dt>発掘のコツを教えてください。</dt>
<dd>一発で出なくても、十発で出なくとも、百発で出なくとも諦めないこと。<a href="#S4-6" title="Webリソース発掘法 連携技で掘り進め！">連携技</a>で手がかりを一段ずつ乗り継ぎ、根気よく進めてください。<a className="dfd" href="#dfn-searchWord">検索語句</a>は増やしたり減らしたりすることも重要ですが、愚直にすべて読んでいくのがそれよりずっと重要であることが多いです。</dd>
</dl>
<h3 id="S7-6">その他の問題</h3>
<dl className="ndl">
<dt>発掘って何ですか。</dt>
<dd>消えたWebの<a className="dfd" href="#dfn-relic">遺物</a>を掘り出して、必要な情報を得る方法のことです。『<a href="#S3" title="Webリソース発掘法 『発掘』とは、どういうことか？">『発掘』とは、どういうことか？</a>』をどうぞ。</dd>
<dt>何を言ってるんだかさっぱりです。</dt>
<dd>『<a href="#S9-2" title="Webリソース発掘法 忙しい人のためのWebリソース発掘法">忙しい人のためのWebリソース発掘法</a>』を。今北産業。</dd>
</dl>
      <h3 id="S7-"><a href="#S7" className="lnk" title="Webリソース発掘法 発掘“ケースバイケース”">発掘“ケースバイケース”</a>の使い方</h3>
      <p>
      <a href="#S7" title="Webリソース発掘法 発掘“ケースバイケース”">発掘“ケースバイケース”</a>は、<a className="dfd" href="#dfn-excavate">発掘</a>中に何か問題が発生したときに使ってください。
      </p><p>
      『<a href="#S7-1" title="Webリソース発掘法 こんなときどうすればいいの？">こんなときどうすればいいの？</a>』から順番に当てはまる項目を選択していけば、問題の解決法が書いてある部分に行きつく、という仕組みです。
      </p>
      <h2 id="S8">実際にやってみた</h2>
      <p>ここから先は発掘の実演です。様々なジャンルの発掘について記載することも考えましたが、普段はもう手に入らなくなったゲームの発掘ばかりしているのであえてゲームだけ3件、難易度順に並べました。</p>
<p>※2026年に追記した部分であるため、時期によっては実際に試した結果がここでの記載と大きく異なる可能性があります</p>
<h2>1. CLOCK【難易度：低】</h2>
<p>実況第一回でもプレイしたやつですね。早速「CLOCK」で検索してみてほしいですが、よほど最適化された検索エンジンでもなければ、これで目的のものが出てくるはずはないと思います。ひと昔前であれば「CLOCK ゲーム」だけでも出てきましたが、2026年現在はいろいろ新しいゲームが出てきてくれたので全然出てこないですね。さて、どういう方法で絞り込みましょうか。</p>
<p>ゲームタイトルと同時にページに記載されている可能性が高いもの、ジャンル・ゲームエンジン……作者名、ですかね。「梓999」は実況第二回でやりましたが作者が同一です。「梓999」で検索すれば作者名が出てきます。「曽我部一郎」氏(復活しないかなぁ)。「CLOCK 曽我部一郎」で検索すると目的のものが出てくるようになります。</p>
<p>1997年、インターネットコンテストパークの月間受賞作で、PC-98のRPGツクール(Dante98)製。情報は出てきますが、ゲーム本体は現在DLできないようです。さて、次はどうしましょうか。潰されたDLリンクを見ていくと、かつては公開されていたことを感じさせるような記載があることがわかります。こういうものを見つけたときには何をすべきでしょうか。</p>
<p>Wayback Machineですよね。時代をさかのぼってリンクをたどると、Wayback Machine経由でclock.exeを手に入れることができます。実はインターネットコンテストパークの月間受賞作ともなると、Wayback Machineにファイルが残っているのです。経験上、昔のもので容量が小さいほどついでに収集されている可能性が高まります。</p>
<p>手に入れたexeをどうすればよいかについても面白い課題ではありますが、実行環境が変わるとすべきことも変わってくるため、一旦ここで完了としておきます。すぐにわかるようなキーワードを組み合わせてWayback Machineにかける。このくらいで解決するのであれば難易度はそんなに高くありません。このくらいでへこたれてはいけませんよ。</p>
<h2>2. missdeather【難易度：中】</h2>
<p>次はうろ覚えのゲームを発掘する試みをしてみましょうか。あれが良いかなと思います。昔プレイしたんですが、確かRPGツクール2000あたりで、画面は完全白黒で、主人公少年の自宅に妹が寝ていて、その妹は寿命が短くて、寿命を延ばすために何かする、的なやつです。うろ覚えであるため実際どの程度正しいかが良くわからないところもネックですね。</p>
<p>「RPGツクール 白黒」で検索してみましょうか。なんとなく画面の感じを覚えているのであれば、画像検索も結構役に立ちます。滅茶苦茶似ているものもチラチラ見かけますが、「白黒」「余命」「延命」などに該当するゲームは世の中にこんなにあるものなのですね。こういう時には根気が重要です。それっぽい言葉をいろいろ入れ替えていけば、急に突然見つかることがあります。</p>
<p>その時は突然やってきました。「白黒」「余命」「延命」と言葉を入れ替えてもそれらしいものは出て来ず、検索に引っかかった“それっぽい候補”を片っ端から見ていくことにしました。停滞少女、眠りねずみは眠り姫になれるのか、余命180……どれも違う。しかし、その「余命180」という別のゲームを確かめようと「余命180 少女 少年」で検索したそのとき、結果の片隅に「名前が思い出せないゲームを誰かが教えてくれるスレ」が紛れ込んでいたのです。</p>
<p>覗いてみたところ、なんと、探していたゲームの条件に驚くほど一致するうろ覚えを書き込んでいる先人がいました。そしてそのレスには、ちゃんと答えが付いていたのです――「missdeather」。主人公とヒロインの余命が時間とともに減っていき、アイテムで延ばしながら進むシステム。そうでした。そういうゲームでしたね。</p>
<p>「余命」「少女」「少年」というようなキーワードが、普段は引っかからないスレッドを偶然引き当てたようです。このように、回り道にも思える検索を行っているときに、急に手掛かりが飛び込んでくることがあります。なので、思ったほど手ごたえがなかったとしても、根気よく続けることが重要なのです。</p>
<h2>3. 青空を見るために・・・【難易度：高】</h2>
<p>「CLOCK」や「missdeather」は、ファンがいてレビューもいくつか転がっている自作ゲーム会の優等生です。しかし、個人的思い入れなどの理由でもっとずっとマイナーなゲームを発掘したくなることもあります。昔Vectorにあった、RPGツクール95製のフリーゲーム。男二人が理不尽な洞窟から地上の青空を目指す、ストーリーもろくにない一本。しかし、当時クリアできなかったという思い出が私を発掘に駆り立てます。</p>
<p>このゲーム、今のVectorを探しても全然ありません。どうも作者が公開停止したようです。Vectorには昔のゲームもかなり残っていて面白いのですが、それでも超昔のゲームとなると消えていることが多いようです(「TIME TOWER」とかも見当たりませんね)。しかし、昔のものを探すならWayback Machineです。今回は極端に昔のリストにさかのぼる必要がありました。2000年のVector。当時はアドベンチャーとRPGがひとつだった一覧を探ってみると、ありました。「青空を見るために・・・」――RPGツクール95で作ったダンジョン迷路型ゲーム」。作者はタカマ氏。</p>
<p>しかし、本体のファイルはWaybackに残っていませんでした。とはいえ、そんなことはよくあることです。Vectorには作者サイトへのリンクがあるのです。今は閉鎖されたGeoCities、懐かしいですね。これもWayback Machineで取得することができました。しかし、作者ホームページのダウンロードリンクからもファイルが消えていたのです。こうなってくるとなかなか難しいところです、また良い方法がひらめくまで塩漬けにしておりました。</p>
<p>そうしていると、ある日ふと気づいたのです。そういえば昔は雑誌付録CD-ROMにソフトウェアが入っていることがあったな、と。このページでガイドしている発掘の範囲からは少し外れてきますが、背に腹は代えられません。調べてみると、Vectorも昔はCD-ROM版（「PACK for WIN」シリーズ）を出していたようです。しかし、最終版『PACK for WIN 1999年後期版』（1999年7月刊）の収録には、11月生まれの「青空を見るために・・・」はほんの半年ほど間に合わなかったようです。絶妙なところを狙ってくるな……。</p>
<p>ところが、ここで急に作者ホームページの情報が生きてきたのです。よく見ると「雑誌掲載記録」というページがあり、そこに「テックウィン別冊 第4号(1999年11月)」に掲載されたという情報があったのです。早速オークションで雑誌を手に入れ、CD-ROMから無事ゲームを回収することができました。CD-ROMにも寿命があるので、この方法をとるのであればそろそろ急いだほうが良いと思います。</p>

      <h2 id="S9">その他あれこれ</h2>
      <p>他の章に属しない話題はここで取り扱います。</p>
      {/*過去の試み（ニコの発掘動画など）、Web墓守、発掘と検索の違い*/}
      <h3 id="S9-1">発掘の歴史</h3>
      <p>インターネットが広まりはじめた頃、データは増える一方で、消えるものといえば作者が意図して閉鎖したページくらいのものでした。しかしその代わり、当時消えたページを追う手がかりといえば、せいぜい誰かが取っておいたミラーサイトくらい。あらかじめ気になるWebページは丸ごとダウンロードして保全しておけば再度アクセスするときにも素早く閲覧可能。発掘は手元のパソコンの記憶メディアから探すところから始める、そういった時代がありました。</p>
<p>そこにInternet Archiveが現れました。Webそのものを片端から集めて保管していくという無茶苦茶を本気でやってくれるらしいのです。収集を始めたのが1996年、その成果を誰でも遡れるWayback Machineが一般公開されたのが2001年。ここが大きな転機で、以後発掘は、リンク切れのページを見つける、時間をさかのぼってまだ生きている時期のリンク先を取得する、そこに張られたリンクをたどる、といった手法をとることができるようになり、かなり進歩しました。</p>
<p>それから、徐々にWebページが閉鎖していく時代に入ります。2000年代、人々は個人サイトからブログ、SNSへと移り、役目を終えた無料サービスが次々と畳まれ始めます。2009年には個人サイトの象徴だったGeoCitiesの米国版が閉鎖。翌2010年には楽天のinfoseek iswebが無料ホームページサービスを終了し、推定で何万ものサイトが一夜にして消えました。前略プロフィールが2016年に、そして2019年には日本のジオシティーズ、Yahoo!ブログ、はてなダイアリーが相次いで閉鎖。もはや昔の姿はWayback MachineやWeb魚拓の中にしか残っていません。</p>
<p>それでも、失われたものを取り戻そうとする人が絶えたことはありません。むしろ発掘のような試みは、ひとつの文化として育ってきました。2chや5chには「名前が思い出せないゲームを誰かが教えてくれるスレ」が代々受け継がれ、ニコニコ動画やYouTubeには「この写真はどこで撮られたのか」「この曲は何か」を追う特定・発掘の動画が積み上がっています。GeoCitiesが日本で閉じる直前には、消える前に丸ごと記録しておこうという有志の動きもありました。こうした先人たちの営みに、発掘はときどき助けられます。探しているものを、すでに誰かが見つけて書き残していたり、消える前に丸ごと記録しておいてくれたり。もっとも、そんな幸運がいつもあるわけではありませんが。</p>
<p>この項は2026年に追記していますが、このページを書き始めた2009年から今までで、発掘の道具立ては思ったほど変わっていません。Wayback Machineは今でも発掘の中心ですし、検索エンジンもしっかり使いこなせばそれなりに結果を返してくれますーーコツはかなり変わりましたが。古の時代の遺物は今でも失われ続けていますが、有志のアーカイブの層もその分厚くなり続けています。結局のところ、どこかに残った写しをたどって消えたものを探すという芯は、ミラーサイトの頃からたいして変わっていないのだと思います。</p>

      <h3 id="S9-2">忙しい人のための<a className="dfd" href="#dfn-excavation">Webリソース発掘法</a></h3>
      <p>
      <a className="dfd" href="#dfn-excavate">発掘</a>ってのは昔の<a className="dfd" href="#dfn-webPage">ページ</a>を見つけ出すことよ。<br />
      やりたいんなら『<a href="#S7" title="Webリソース発掘法 発掘“ケースバイケース”">発掘“ケースバイケース”</a>』に行ってみ。<br />
      雰囲気だけってことなら『<a href="#S8" title="Webリソース発掘法 実際にやってみた">実際にやってみた</a>』で一つ二つ見ればいいよ。<br />
      以上！<br />
      </p>
      <h2 id="S10">用語集</h2>
      <p>このページに出てくるわかりにくい単語をまとめてみました。五十音順です。</p>
      <dl className="ndl">
      <dt><dfn id="dfn-archive">アーカイブ</dfn> [あーかいぶ]</dt>
      <dd>ここでは、<a className="dfd" href="#dfn-worldWideWeb">Web</a>の一部を<a className="dfd" href="#dfn-compile">収集</a>して<a className="dfd" href="#dfn-secure">保管</a>してある場所。<a className="dfd" href="#dfn-compile">収集</a>時点の<a className="dfd" href="#dfn-webPage">Webページ</a>を見ることができる。</dd>
      <dd>参照：<a href="#S6-3" title="Webリソース発掘法 Internet Archive Wayback Machine">Internet Archive Wayback Machine</a></dd>
      <dt><dfn id="dfn-relic">遺物</dfn> [いぶつ]</dt>
      <dd>ここでは、<a className="dfd" href="#dfn-worldWideWeb">Web</a>に散らばっているオリジナルデータのコピー。</dd>
      <dd>参照：<a href="#S3-3" title="Webリソース発掘法 消しても消えない遺物たち">消しても消えない遺物たち</a></dd>
      <dt><dfn id="dfn-internet">インターネット</dfn> [いんたーねっと]</dt>
      <dd>インターネット・プロトコル(IP)というルールに従って相互接続されたコンピュータネットワーク。</dd>
      <dt><dfn id="dfn-internetArchive">Internet Archive</dfn> [いんたーねっと-あーかいぶ] <a title="Internet Archive" href="http://www.archive.org/">http://www.archive.org/</a></dt>
      <dd>研究者等のために<a className="dfd" href="#dfn-webPage">Webページ</a>の図書館を作らんとする団体。</dd>
      <dd>参照：<a href="#S6-3" title="Webリソース発掘法 Internet Archive Wayback Machine">Internet Archive Wayback Machine</a></dd>
      <dt><dfn id="dfn-waybackMachine">Wayback Machine</dfn> [うぇいばっく-ましーん] <a title="Wayback Machine" href="http://www.archive.org/web/web.php">http://www.archive.org/web/web.php</a></dt>
      <dd><a className="dfd" href="#dfn-internetArchive">Internet Archive</a>の<a className="dfd" href="#dfn-compile">収集</a>した情報をもとに過去の<a className="dfd" href="#dfn-webPage">Webページ</a>を見ることができるサービス。</dd>
      <dd>参照：<a href="#S6-3" title="Webリソース発掘法 Internet Archive Wayback Machine">Internet Archive Wayback Machine</a></dd>
      <dt><span className="dfn">Web</span> [うぇぶ]</dt><dd>= <a className="dfd" href="#dfn-worldWideWeb">World Wide Web</a></dd>
      <dt><dfn id="dfn-webSite">Webサイト</dfn> [うぇぶ-さいと] (さいと)</dt>
      <dd>ひとまとまりに公開されている<a className="dfd" href="#dfn-webPage">Webページ</a>の集合体。</dd>
      <dt><dfn id="dfn-webPage">Webページ</dfn> [うぇぶ-ぺーじ] (ページ)</dt>
      <dd><a className="dfd" href="#dfn-worldWideWeb">Web</a>に属する個々の文書。</dd>
      <dt><dfn id="dfn-excavation">Webリソース発掘法</dfn> [うぇぶ-りそーす-はっくつ-ほう] (発掘法)</dt>
      <dd><a className="dfd" href="#dfn-worldWideWeb">Web</a>から<a className="dfd" href="#dfn-relic">遺物</a>を見つけだすことによって必要な情報を得る方法。</dd>
      <dd>参照：<a href="#S3" title="Webリソース発掘法 『発掘』とは、どういうことか？">『発掘』とは、どういうことか？</a></dd>
      <dt><dfn id="dfn-secure">確保</dfn> [かくほ] (保管)</dt>
      <dd>ここでは、情報を自分の管理下に置いて自然消滅を防ぐこと。</dd>
      <dt><dfn id="dfn-imageboard">画像掲示板</dfn> [がぞう-けいじばん]</dt>
      <dd>画像を張り付けることができる<a className="dfd" href="#dfn-bulletinBoardSystem">掲示板</a>。</dd>
      <dt><dfn id="dfn-imageSearch">画像検索</dfn> [がぞう-けんさく]</dt>
      <dd>ここでは、<a className="dfd" href="#dfn-worldWideWeb">Web</a>に存在する画像を<a className="dfd" href="#dfn-search">検索</a>すること。</dd>
      <dd>参照：<a href="#S6-2-4" title="Webリソース発掘法 検索種別">検索種別</a></dd>
      <dt><dfn id="dfn-google">Google</dfn> [ぐーぐる] <a title="Google" href="http://www.google.com/">http://www.google.com/</a></dt>
      <dd>1998年設立の企業。また、そこの運営する<a className="dfd" href="#dfn-searchEngine">検索エンジン</a>。</dd>
      <dd>参照：<a href="#S6-2-5" title="Webリソース発掘法 検索エンジンの選択">検索エンジンの選択</a></dd>
      <dt><dfn id="dfn-bulletinBoardSystem">掲示板</dfn> [けいじばん]</dt>
      <dd>コンピュータネットワーク上で記事の書き込み、閲覧、コメントの書き込みを行えるシステム。</dd>
      <dt><dfn id="dfn-search">検索</dfn> [けんさく]</dt>
      <dd>情報の集合（ここでは主に<a className="dfd" href="#dfn-worldWideWeb">Web</a>）から目的の情報を探し出すこと。</dd>
      <dd>参照：<a href="#S6-2" title="Webリソース発掘法 検索エンジン">検索エンジン</a></dd>
      <dt><dfn id="dfn-searchEngine">検索エンジン</dfn> [けんさく-えんじん]</dt>
      <dd>文字列を元に<a className="dfd" href="#dfn-internet">インターネット</a>から目的の情報を探し出すプログラム。</dd>
      <dd>参照：<a href="#S6-2" title="Webリソース発掘法 検索エンジン">検索エンジン</a></dd>
      <dt><dfn id="dfn-searchOption">検索オプション</dfn> [けんさく-おぷしょん]</dt>
      <dd><a className="dfd" href="#dfn-search">検索</a>前に選択する追加設定。特殊な条件で<a className="dfd" href="#dfn-search">検索</a>を行うことが出来る。</dd>
      <dd>参照：<a href="#S6-2-3" title="Webリソース発掘法 検索オプション">検索オプション</a></dd>
      <dt><dfn id="dfn-searchResult">検索結果</dfn> [けんさく-けっか]</dt>
      <dd><a className="dfd" href="#dfn-search">検索</a>の結果、見つけ出された目的の情報候補。</dd>
      <dt><dfn id="dfn-searchWord">検索語句</dfn> [けんさく-ごく]</dt>
      <dd><a className="dfd" href="#dfn-search">検索</a>に使用する文字列の中で実際に探し出したい内容を示す語句。</dd>
      <dt><span className="dfn">サイト</span> [さいと]</dt><dd>= <a className="dfd" href="#dfn-webSite">Webサイト</a></dd>
      <dt><dfn id="dfn-refineSearch">絞り込み検索</dfn> [しぼりこみ-けんさく]</dt>
      <dd><a className="dfd" href="#dfn-searchWord">検索語句</a>を追加して<a className="dfd" href="#dfn-searchResult">検索結果</a>件数を減らすこと。</dd>
      <dt><dfn id="dfn-compile">収集</dfn> [しゅうしゅう]</dt>
      <dd>ここでは、情報を<a className="dfd" href="#dfn-secure">確保</a>し、利用できる状態に整理すること。</dd>
      <dt><span className="dfn">WWW</span> [だぶりゅー-だぶりゅー-だぶりゅー]</dt><dd>= <a className="dfd" href="#dfn-worldWideWeb">World Wide Web</a></dd>
      <dt><dfn id="dfn-videoSearch">動画検索</dfn> [どうが-けんさく]</dt>
      <dd>ここでは、<a className="dfd" href="#dfn-worldWideWeb">Web</a>に存在する動画を<a className="dfd" href="#dfn-search">検索</a>すること。</dd>
      <dd>参照：<a href="#S6-2-4" title="Webリソース発掘法 検索種別">検索種別</a></dd>
      <dt><dfn id="dfn-topPage">トップページ</dfn> [とっぷ-ぺーじ]</dt>
      <dd><a className="dfd" href="#dfn-webSite">Webサイト</a>の入り口にあたる<a className="dfd" href="#dfn-webPage">ページ</a>。</dd>
      <dt><dfn id="dfn-domain">ドメイン</dfn> [どめいん]</dt>
      <dd><a className="dfd" href="#dfn-internet">インターネット</a>上の住所のようなもので、コンピュータなどを識別するための名前。</dd>
      <dt><dfn id="dfn-excavate">発掘</dfn> [はっくつ]</dt>
      <dd><a className="dfd" href="#dfn-excavation">Webリソース発掘法</a>を利用して情報を手に入れること。</dd>
      <dd>参照：<a href="#S3" title="Webリソース発掘法 『発掘』とは、どういうことか？">『発掘』とは、どういうことか？</a></dd>
      <dt><span className="dfn">発掘法</span> [はっくつ-ほう]</dt><dd>= <a className="dfd" href="#dfn-excavation">Webリソース発掘法</a></dd>
      <dt><span className="dfn">ページ</span> [ぺーじ]</dt><dd>= <a className="dfd" href="#dfn-webPage">Webページ</a></dd>
      <dt><span className="dfn">保管</span> [ほかん]</dt><dd>= <a className="dfd" href="#dfn-secure">確保</a></dd>
      <dt><dfn id="dfn-summarySite">まとめサイト</dfn> [まとめ-さいと]</dt>
      <dd>特定の情報・作品を<a className="dfd" href="#dfn-compile">収集</a>した<a className="dfd" href="#dfn-webSite">Webサイト</a>。</dd>
      <dt><dfn id="dfn-mirrorSite">ミラーサイト</dfn> [みらー-さいと]</dt>
      <dd>アクセス分散や削除対策のために作られる、ある<a className="dfd" href="#dfn-webSite">Webサイト</a>と全く同じ内容をもつ<a className="dfd" href="#dfn-webSite">サイト</a>のこと。</dd>
      <dt><dfn id="dfn-yahoo">Yahoo!</dfn> [やふー] <a title="Yahoo!" href="http://www.yahoo.com/">http://www.yahoo.com/</a></dt>
      <dd>個人<a className="dfd" href="#dfn-webSite">サイト</a>から始まった<a className="dfd" href="#dfn-internet">インターネット</a>関連サービス企業。また、そこの運営する<a className="dfd" href="#dfn-searchEngine">検索エンジン</a>。</dd>
      <dd>参照：<a href="#S6-2-5" title="Webリソース発掘法 検索エンジンの選択">検索エンジンの選択</a></dd>
      <dt><dfn id="dfn-URL">URL</dfn> [ゆー-あーる-える]</dt>
      <dd><a className="dfd" href="#dfn-internet">インターネット</a>上でデータの位置を示す文字列。Uniform Resource Locator。</dd>
      <dt><dfn id="dfn-capacity">容量</dfn> [ようりょう]</dt>
      <dd>ここでは、記憶媒体に保存できる情報量のこと。</dd>
      <dt><dfn id="dfn-worldWideWeb">World Wide Web</dfn> [わーるど-わいど-うぇぶ] (Web,WWW)</dt>
      <dd><a className="dfd" href="#dfn-internet">インターネット</a>上でハイパーテキストを利用し、文書同士を相互に参照可能としたシステム。</dd>
      </dl>
      <address>
      AntennaJane　2009-09-09 作成　2026-07-25 更新
      </address>
    </div>
  );
}
